<template>
  <img :src="src" class="image" :class="[{turn_over: isTurnOver}, unitType]" />
</template>

<script>
export default {
  props: {
    unitType: String,
    season: String,
  },
  data() {
    return {
      isTurnOver: Math.random() > 0.5,
    };
  },
  computed: {
    src() {
      try {
        const seasonalImage = require(`@/assets/img/units/${this.unitType}/${
          this.season
        }.png`);
        return seasonalImage;
      } catch (e) {
        return require(`@/assets/img/units/${this.unitType}/default.png`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.turn_over {
  transform: scale(-1, 1);
}

.d_tree1_seed,
.d_tree2_seed,
.d_tree3_seed,
.s_tree1_seed,
.s_tree2_seed,
.s_tree3_seed {
  width: 30px;
  // margin-bottom: -25%;
}

.d_tree3_seed {
  margin-bottom: -28%;
}

.d_tree1_sprout,
.d_tree2_sprout,
.d_tree3_sprout {
  width: 60px;
  margin-bottom: -40%;
}

.d_tree3_sprout {
  margin-bottom: -50%;
}

.s_tree1_sprout,
.s_tree2_sprout,
.s_tree3_sprout {
  width: 60px;
}

.s_tree1_sprout {
  margin-bottom: -25%;
}

.s_tree2_sprout {
  margin-bottom: -28%;
}

.s_tree3_sprout {
  margin-bottom: -68%;
}

.d_tree1_child,
.d_tree2_child,
.d_tree3_child {
  width: 80px;
  margin-bottom: -45%;
}

.s_tree1_child,
.s_tree2_child,
.s_tree3_child {
  width: 80px;
  margin-bottom: -30%;
}

.s_tree2_child {
  margin-bottom: -20%;
}

.d_tree1_young,
.d_tree2_young,
.d_tree3_young {
  width: 120px;
}

.d_tree1_young {
  margin-bottom: -33%;
}

.d_tree2_young {
  margin-bottom: -55%;
}

.d_tree3_young {
  margin-bottom: -62%;
}

.s_tree1_young,
.s_tree2_young,
.s_tree3_young {
  width: 120px;
  margin-bottom: -90%;
}

.s_tree1_young {
  margin-bottom: -50%;
}

.s_tree2_young {
  margin-bottom: -72%;
}

.d_tree1_adult,
.d_tree2_adult,
.d_tree3_adult {
  width: 200px;
}

.d_tree1_adult {
  margin-bottom: -30%;
}

.d_tree2_adult {
  margin-bottom: -10%;
}

.d_tree3_adult {
  margin-bottom: -50%;
}

.s_tree1_adult,
.s_tree2_adult,
.s_tree3_adult {
  width: 160px;
  margin-bottom: -70%;
}

.s_tree1_adult {
  margin-bottom: -62%;
}

.s_tree3_adult {
  margin-bottom: -80%;
}
</style>



// WEBPACK FOOTER //
// src/components/game/UnitImage.vue